import React, { useState, useEffect } from "react";
import ProductFavorite from "./ProductFavorite";
import Loader2 from "../../Components/Loader2";
import { language } from "../../language/Language";
import { getFavorites, saveFavorites } from "../../utils/localStorage";
import { Helmet } from "react-helmet";
import { useGetAllProductsQuery } from "../../RTK/Slices/Slices/apiSliceMeat";

const FavoriteList = () => {
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // جلب جميع المنتجات لتحديث الأسعار والمخزون
  const { data: productsData, isLoading: isApiLoading } = useGetAllProductsQuery(
    { per_page: 500 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    const favoritesFromStorage = getFavorites();
    
    if (!isApiLoading && productsData?.data) {
      const apiProducts = productsData.data;
      
      // تحديث بيانات المنتجات في المفضلة بناءً على أحدث بيانات من الـ API
      const updatedFavorites = favoritesFromStorage.map(fav => {
        const latestProduct = apiProducts.find(p => p.product_id === fav.product_id);
        if (latestProduct) {
          return {
            ...fav,
            price: latestProduct.price,
            discount: latestProduct.default_sales_discount || 0,
            stock: latestProduct.stock,
            item_name: latestProduct.name,
            icon: latestProduct.image_url
          };
        }
        return fav;
      });

      // حفظ التحديثات في localStorage
      saveFavorites(updatedFavorites);
      // تحديث الـ state بـ spread جديد لضمان re-render
      setFavorites([...updatedFavorites]);
      setIsLoading(false);
    } else if (!isApiLoading) {
      setFavorites([...favoritesFromStorage]);
      setIsLoading(false);
    }
  }, [isApiLoading, productsData]);

  // دالة لتحديث المفضلة عند إزالة منتج
  const updateFavorites = () => {
    const updatedFavorites = getFavorites();
    setFavorites(updatedFavorites);
  };

  // Handle loading state
  if (isLoading || isApiLoading) {
    return (
      <div className="container mt-28 h-[70vh] grid place-items-center">
        <Loader2 />
      </div>
    );
  }

  // إذا لم توجد منتجات مفضلة
  if (favorites.length === 0) {
    return (
      <div className="container mt-28">
        <Helmet>
          <title>Meat-House El-Fardos</title>
          <meta
            name="description"
            content="استعرض قائمة اللحوم والمنتجات المفضلة لديك في Meat House واطلبها بسهولة مع توصيل سريع وجودة مضمونة."
          />
        </Helmet>
        <h2 className="text-xl sm:text-3xl font-extrabold text-gray-800 mb-6 sm:mb-8">
          {language === "ar" ? "المنتجات المفضلة" : "Favorite Products"}
        </h2>
        <div className="text-center py-20">
          <p className="text-lg text-gray-600">
            {language === "ar"
              ? "لا توجد منتجات مفضلة حتى الآن"
              : "No favorite products yet"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container my-28">
      <Helmet>
        <title>Meat-House El-Fardos</title>
        <meta
          name="description"
          content="استعرض قائمة اللحوم والمنتجات المفضلة لديك في Meat House واطلبها بسهولة مع توصيل سريع وجودة مضمونة."
        />
      </Helmet>
      <h2 className="text-xl sm:text-3xl font-extrabold text-gray-800 mb-6 sm:mb-8">
        {language === "ar" ? "المنتجات المفضلة" : "Favorite Products"}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
        {favorites.map((product) => (
          <ProductFavorite
            key={`${product.product_id}-${product.price}-${product.discount}`}
            product={product}
            onUpdateFavorites={updateFavorites}
          />
        ))}
      </div>
    </div>
  );
};

export default FavoriteList;
